import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';
import { DiamondWarningIcon } from './icons/DiamondWarningIcon';
import { TriangleWarningIcon } from './icons/TriangleWarningIcon';
interface BundleAuthorizationCalloutProps {
  /** `destructive` (diamond, blocks the CTA) or `warning` (triangle, informational). */
  variant: 'destructive' | 'warning';
  message: string;
  className?: string;
  'data-testid'?: string;
}

/**
 * Figma callout shown when a token issuer hasn't whitelisted the bundle
 * contract an operation is routed through (permissioned assets only).
 */
const BundleAuthorizationCallout = t0 => {
  const $ = _c(17);
  const {
    variant,
    message,
    className,
    "data-testid": t1
  } = t0;
  const testId = t1 === undefined ? "bundle-authorization-callout" : t1;
  const isDestructive = variant === "destructive";
  const t2 = isDestructive ? "bg-destructive" : "bg-warning";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("flex items-center gap-sm rounded-lg p-sm", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isDestructive ? "text-destructive-foreground" : "text-warning-foreground";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("shrink-0", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isDestructive) {
    t6 = isDestructive ? <DiamondWarningIcon /> : <TriangleWarningIcon />;
    $[5] = isDestructive;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== message) {
    t8 = <p className="text-foreground text-xs leading-[1.6]">{message}</p>;
    $[10] = message;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t7 || $[14] !== t8 || $[15] !== testId) {
    t9 = <div role="alert" data-testid={testId} className={t3}>{t7}{t8}</div>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
    $[15] = testId;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default memo(BundleAuthorizationCallout);